
import { RISE_COLOR, FALL_COLOR} from '@/const/color';
// 涨跌颜色配置，A股市场涨是红色，跌是绿色，其他涨是绿色，跌是红色
export const RISE_FALL_COLOR_CONFIG = {
   up: {
    cn: RISE_COLOR, // 红色
    default: FALL_COLOR // 绿色
  },
  down: {
    cn: FALL_COLOR, // 绿色
    default: RISE_COLOR // 红色
  }
}